"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = App;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Thats is the root component that is rendered in the Widget
function App() {
  /**
   * to use the configuration given by the app builder use the
   * you can use useConfig() hook to get the Config if you give
   * the hook the path for the property in your configuration
   * it will retrieve the value if you leave it empty
   * it will retrieve the whole config object
   * ex: const config = useConfig() ||
   * const { conf1, conf2,conf3 } = useConfig() ||
   * const conf1 = useConfig('conf1')
   */

  /**
   * useProps() hook works the same as
   * useConfig but retrieves the Widget Properties
   */

  /**
   * useOtherWidgetState hook works the same as use Config and
   * useProps and it is used if you want to get a state that is
   * in another widget it
   */
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
}